export const DEFAULT_ACCEPT = 'image/*,.pdf';

export const FILE_LOAD_TIMEOUT_MS = 1000;
export const FILE_PROGRESS_ANIMATION_DELAY_MS = 20;

export const DELETE_CONFIRMATION_TITLE = 'Are you sure?';
export const DELETE_CONFIRMATION_CANCEL = 'No, keep file';
export const DELETE_CONFIRMATION_CONFIRM = 'Yes, delete';
export const DELETE_MODAL_CLOSE_DURATION_MS = 180;
